module.exports = __webpack_public_path__ + "img/messageImage_1770606014089.f14c4ce4.jpg";